(function () {
  'use strict';

  var STORAGE_KEY = 'zapietSelectionState';

  var CONFIG = {
    deliveryPostcodeSelector: '#deliveryGeoSearchField',
    deliveryAutocompleteListSelector: '.Zapiet-Autocomplete__List',
    widgetRootSelector: '#storePickupApp',

    selectedStateClassPattern:
      'active|selected|is-selected|is-active',

    asyncWaitTimeoutMs: 6000,

   
    restoreAttempts: 40,
    restoreIntervalMs: 250
  };

 
  function readState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeState(patch) {
    try {
      var current = readState() || {};

      var next = Object.assign({}, current, patch, {
        savedAt: Date.now()
      });

      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (e) {
     
    }
  }

  function clearState() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function isStateFresh(state) {
    if (!state || !state.savedAt) return false;

    var MAX_AGE_MS = 2 * 60 * 60 * 1000;

    return Date.now() - state.savedAt < MAX_AGE_MS;
  }


  function getWidgetRoot() {
    return document.querySelector(CONFIG.widgetRootSelector);
  }

  function isSelectedElement(el) {
    if (!el) return false;

    if (
      el.getAttribute &&
      (
        el.getAttribute('aria-pressed') === 'true' ||
        el.getAttribute('aria-selected') === 'true'
      )
    ) {
      return true;
    }

    if (!el.className || typeof el.className !== 'string') {
      return false;
    }

    var re = new RegExp(
      '(^|\\s)(' + CONFIG.selectedStateClassPattern + ')(\\s|$)'
    );

    return re.test(el.className);
  }

  function setNativeInputValue(input, value) {
    var setter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      'value'
    ).set;

    setter.call(input, value);
  }

  function whenZapietEventReady(callback, attemptsLeft) {
    attemptsLeft =
      attemptsLeft === undefined
        ? 40
        : attemptsLeft;

    if (
      window.ZapietEvent &&
      typeof window.ZapietEvent.listen === 'function'
    ) {
      callback();
      return;
    }

    if (attemptsLeft <= 0) return;

    setTimeout(function () {
      whenZapietEventReady(callback, attemptsLeft - 1);
    }, 250);
  }

 
  function attemptRestoreMethod(state) {
    if (!state || !state.method) return;

    if (
      window.Zapiet &&
      typeof window.Zapiet.setCheckoutMethod === 'function'
    ) {
      try {
        window.Zapiet.setCheckoutMethod(state.method);
      } catch (e) {}
    }
  }


  function attemptRestoreLocation(state) {
    if (!state || !state.locationId) return;

    var candidate = document.querySelector(
      '[data-zapiet-location-id="' + state.locationId + '"]'
    );

    if (candidate) {
      candidate.click();
    }
  }


  function capturePostcodeInput() {
    document.addEventListener(
      'input',
      function (evt) {
        var el = evt.target;

        if (
          el &&
          el.matches &&
          el.matches(CONFIG.deliveryPostcodeSelector)
        ) {
          writeState({
            deliveryPostcode: el.value
          });
        }
      },
      true
    );

    document.addEventListener(
      'click',
      function (evt) {
        var selector =
          CONFIG.deliveryAutocompleteListSelector + ' li, ' +
          CONFIG.deliveryAutocompleteListSelector + ' [role="option"]';

        var el = evt.target.closest
          ? evt.target.closest(selector)
          : null;

        if (el) {
          writeState({
            deliveryAddressText: (el.textContent || '').trim()
          });
        }
      },
      true
    );
  }

 
  function captureSlotClicks() {
    var attach = function () {
      var root = getWidgetRoot();

      if (!root || root.__zapietSlotCaptureAttached) return;

      root.__zapietSlotCaptureAttached = true;

      root.addEventListener(
        'click',
        function (evt) {
          var rawTarget = evt.target;

          setTimeout(function () {
            var el = rawTarget.closest
              ? rawTarget.closest('button, [role="button"], li, div')
              : rawTarget;

            if (el && isSelectedElement(el)) {
              var text = (el.textContent || '')
                .trim()
                .replace(/\s+/g, ' ');

              if (text && text.length < 60) {
                var current = readState() || {};
                var slots = current.selectedSlotsText || [];

                if (slots.indexOf(text) === -1) {
                  slots.push(text);

                  if (slots.length > 4) {
                    slots.shift();
                  }

                  writeState({
                    selectedSlotsText: slots
                  });
                }
              }
            }
          }, 50);
        },
        true
      );
    };

    var tries = 0;

    var iv = setInterval(function () {
      tries++;

      attach();

      if (getWidgetRoot() || tries > 20) {
        clearInterval(iv);
      }
    }, 250);
  }


  function waitForDeliveryInput(callback) {
    var attempts = 0;

    var timer = setInterval(function () {
      attempts++;

      var input = document.querySelector(
        CONFIG.deliveryPostcodeSelector
      );

      if (input) {
        clearInterval(timer);
        callback(input);
        return;
      }

      if (attempts >= CONFIG.restoreAttempts) {
        clearInterval(timer);
        callback(null);
      }
    }, CONFIG.restoreIntervalMs);
  }


  function attemptRestoreDelivery(state, done) {
    if (
      !state ||
      (!state.deliveryPostcode && !state.deliveryAddressText)
    ) {
      done();
      return;
    }

    waitForDeliveryInput(function (input) {
      if (!input) {
        done();
        return;
      }

      var value =
        state.deliveryPostcode ||
        state.deliveryAddressText;

 
      setNativeInputValue(input, value);


      input.dispatchEvent(
        new Event('input', { bubbles: true })
      );

      input.dispatchEvent(
        new Event('change', { bubbles: true })
      );

      input.dispatchEvent(
        new Event('keyup', { bubbles: true })
      );


      waitForAutocompleteAndSelect(state, done);
    });
  }


  function waitForAutocompleteAndSelect(state, done) {
    var waited = 0;
    var interval = 200;

    var timer = setInterval(function () {
      waited += interval;

      var list = document.querySelector(
        CONFIG.deliveryAutocompleteListSelector
      );

      var items = list
        ? list.querySelectorAll('li, [role="option"]')
        : [];

      if (items && items.length) {
        clearInterval(timer);

        var target = items[0];


        if (state.deliveryAddressText) {
          for (var i = 0; i < items.length; i++) {
            if (
              (items[i].textContent || '').trim() ===
              state.deliveryAddressText
            ) {
              target = items[i];
              break;
            }
          }
        }

        target.click();

  
        done();
        return;
      }

      if (waited >= CONFIG.asyncWaitTimeoutMs) {
        clearInterval(timer);


        done();
      }
    }, interval);
  }


  function attemptRestoreSlots(state) {
    if (
      !state ||
      !state.selectedSlotsText ||
      !state.selectedSlotsText.length
    ) {
      return;
    }

    var waited = 0;
    var interval = 300;
    var remaining = state.selectedSlotsText.slice();

    var timer = setInterval(function () {
      waited += interval;

      var root = getWidgetRoot();

      if (root) {
        remaining = remaining.filter(function (text) {
          var els = root.querySelectorAll(
            'button, [role="button"], li, div'
          );

          for (var i = 0; i < els.length; i++) {
            if (
              (els[i].textContent || '').trim() === text &&
              !isSelectedElement(els[i])
            ) {
              els[i].click();
              return false;
            }
          }

          return true;
        });
      }

      if (
        !remaining.length ||
        waited >= CONFIG.asyncWaitTimeoutMs
      ) {
        clearInterval(timer);
      }
    }, interval);
  }


  capturePostcodeInput();
  captureSlotClicks();

  whenZapietEventReady(function () {

    window.ZapietEvent.listen(
      'selected_method',
      function (method) {
        writeState({
          method: method
        });
      }
    );


    window.ZapietEvent.listen(
      'locationSelected',
      function (loc) {
        writeState({
          locationId: loc && (loc.id || loc.locationId),
          locationName: loc && loc.name
        });
      }
    );

  
    window.ZapietEvent.listen(
      'widget_loaded',
      function () {
        var state = readState();

        if (!state || !isStateFresh(state)) {
          clearState();
          return;
        }

        setTimeout(function () {
        
          attemptRestoreMethod(state);

          
          attemptRestoreLocation(state);

         
          attemptRestoreDelivery(state, function () {
          
            attemptRestoreSlots(state);
          });

        }, 150);
      }
    );
  });

})();
